<template>
	<div>
		<div v-if="!edit" style="position:absolute;left:50px;top:50px;">
			<button class="btn_class" @click="edit = true">编辑</button>
		</div>
		<div class="content">
			<div style="margin-bottom:39px;">
				<div class="left">
					<div class="create_form_item">
						<span class="require">*</span>
						<span class="title">姓名</span>
						<input
							:readonly="!edit"
							:style="!edit ? 'border:none;' : ''"
							v-model="userInfor.realname"
							type="text"
							placeholder=""
						/>
					</div>
					<div class="create_form_item">
						<span class="require">*</span>
						<span class="title">性别</span>
						<RadioGroup v-model="userInfor.sex">
							<Radio
								label="1"
								style="margin-right:100px;"
								:disabled="!edit"
								>男</Radio
							>
							<Radio label="2" :disabled="!edit">女</Radio>
						</RadioGroup>
					</div>
					<div class="create_form_item">
						<span class="require">*</span>
						<span class="title">联系电话</span>
						<input
							:readonly="!edit"
							:style="!edit ? 'border:none;' : ''"
							v-model="userInfor.phone"
							type="text"
							placeholder=""
						/>
					</div>
					<div class="create_form_item">
						<!-- <span class="require">*</span> -->
						<span class="title">从业编号</span>
						<input
							:readonly="!edit"
							:style="!edit ? 'border:none;' : ''"
							v-model="userInfor.congyeNum"
							type="text"
							placeholder=""
						/>
					</div>
					<div class="create_form_item">
						<!-- <span class="require">*</span> -->
						<span class="title">执业证号</span>
						<input
							:readonly="!edit"
							:style="!edit ? 'border:none;' : ''"
							v-model="userInfor.zhiyeNum"
							type="text"
							placeholder=""
						/>
					</div>
					<div class="create_form_item">
						<!-- <span class="require">*</span> -->
						<span class="title">证书有效期</span>
						<DatePicker
							type="date"
							style="width: 243px"
							v-if="edit"
							@on-change="datachange"
							v-model="userInfor.certificateExpirationTime"
						></DatePicker>
						<input
							:readonly="!edit"
							:style="!edit ? 'border:none;' : ''"
							v-else
							v-model="userInfor.certificateExpirationTime"
							type="text"
							placeholder=""
						/>
					</div>
					<div class="create_form_item">
						<span class="require">&nbsp;&nbsp;</span>
						<span class="title">帐号</span>
						<input
							readonly
							style="border:none;"
							v-model="userInfor.userName"
							type="text"
							placeholder=""
						/>
					</div>
					<div class="create_form_item">
						<span class="require">&nbsp;&nbsp;</span>
						<span class="title">从业机构</span>
						<input
							readonly
							style="border:none;"
							v-model="userInfor.companyName"
							type="text"
							placeholder=""
						/>
					</div>
					<div class="create_form_item">
						<span class="require">&nbsp;&nbsp;</span>
						<span class="title">归属门店</span>
						<input
							readonly
							style="border:none;"
							v-model="userInfor.storeName"
							type="text"
							placeholder=""
						/>
					</div>
					<div class="create_form_item">
						<span class="require">&nbsp;&nbsp;</span>
						<span class="title">角色</span>
						<input
							readonly
							style="border:none;"
							v-model="userInfor.roleName"
							type="text"
							placeholder=""
						/>
					</div>
				</div>
				<div class="right">
					<div class="imgupload">
						<img
							:src="
								userInfor.avatar
									? userInfor.avatar.indexOf('http') == -1
										? globelurl + userInfor.avatar
										: userInfor.avatar
									: img
							"
							alt=""
							v-if="edit"
						/>
						<img
							:src="
								userInfor.avatar
									? userInfor.avatar.indexOf('http') == -1
										? globelurl + userInfor.avatar
										: userInfor.avatar
									: img
							"
							alt=""
							v-else
						/>
						<input
							name="fileupload"
							type="file"
							@change="uploadListchange($event)"
							id="imgInput1"
							v-if="edit"
						/>
					</div>
				</div>
			</div>
			<div style="text-align:center;" v-if="edit">
				<button class="btn_class" @click="editmyinfor">保存</button>
			</div>
		</div>
	</div>
</template>
<script>
import { admin } from '@/api/admin'
import { globelurl, upimg } from '@/api/axios.js'
// import img from "@/assets/img/personimg.png";
import img from '@/assets/img/imgupload.png'
import uploadimg from '@/assets/img/upload1.png'
import moment from 'moment'
export default {
	name: 'HelloWorld',
	props: {
		msg: String
	},
	data() {
		return {
			// 个人资料
			edit: false,
			userInfor: {},
			img: img,
			uploadimg: uploadimg,
			globelurl: globelurl
		}
	},
	mounted() {
		this.getinfor()
		// this.getstoreList();
	},
	methods: {
		getinfor() {
			admin.getaccountInfor('').then(res => {
				if (res.data.success == true) {
					this.userInfor = res.data.result
					if (this.userInfor.sex == '男') {
						this.userInfor.sex = '1'
					} else {
						this.userInfor.sex = '2'
					}
					if (this.userInfor.zhiyeNum) {
						this.userInfor.certificateExpirationTime = moment(
							this.userInfor.certificateExpirationTime
						).format('YYYY-MM-DD')
					} else {
						this.userInfor.certificateExpirationTime = ''
					}
				}
			})
		},
		uploadListchange(e) {
			for (var i = 0; i < e.target.files.length; i++) {
				var file = e.target.files[i]
				if (file.size / 1024 > 10240) {
					this.$Message.error('文件太大了，不得超过10M')
					return
				}
				var param = new FormData()
				param.append('file', file, file.name) //通过append向form对象添加数据
				upimg(param).then(res => {
					if (res) {
						document.getElementById('imgInput1').value = ''
						this.userInfor.avatar = res.data.result.pathList[0]
					}
				})
			}
		},
		datachange(v) {
			this.userInfor.certificateExpirationTime = v
		},
		editmyinfor() {
			if (!this.userInfor.realname) {
				this.$Message.error('请输入姓名')
				return
			}
			if (!this.userInfor.sex) {
				this.$Message.error('请选择性别')
				return
			}
			if (!this.userInfor.phone) {
				this.$Message.error('请输入联系电话')
				return
			}
			if (
				this.userInfor.phone &&
				!/^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/.test(
					this.userInfor.phone
				)
			) {
				this.$Message.error('请正确的联系电话')
				return
			}
			if (
				this.userInfor.zhiyeNum ||
				this.userInfor.certificateExpirationTime
			) {
				if (
					!this.userInfor.zhiyeNum ||
					!this.userInfor.certificateExpirationTime
				) {
					this.$Message.error('请填写完整执业证书信息')
					return
				}
			}
			// if (!this.userInfor.congyeNum) {
			//     this.$Message.error("请填写从业编号");
			//     return;
			// }
			// if (!this.userInfor.zhiyeNum) {
			//     this.$Message.error("请填写执业证号");
			//     return;
			// }
			// if (!this.userInfor.certificateExpirationTime) {
			//     this.$Message.error("请选择证书有效期");
			//     return;
			// }
			let obj = {}
			for (var k in this.userInfor) {
				if (
					k == 'realname' ||
					k == 'sex' ||
					k == 'phone' ||
					k == 'congyeNum' ||
					k == 'zhiyeNum' ||
					k == 'certificateExpirationTime' ||
					k == 'avatar' ||
					k == 'userId'
				) {
					obj[k] = this.userInfor[k]
				}
			}
			admin.editmyinfor(obj).then(res => {
				if (res.data.success == true) {
					sessionStorage.realName = this.userInfor.realname
					this.$router.go(-1)
				} else {
					this.$Message.error(res.data.message)
				}
			})
		}
	}
}
</script>

<style scoped>
.content {
	width: 700px;
	margin: 145px auto 60px;
	position: relative;
}
.left {
	width: 500px;
	display: inline-block;
}
.right {
	display: inline-block;
	vertical-align: top;
}
.create_form_item {
	margin-bottom: 30px;
}

.create_form_item .require {
	color: #ff1812;
	font-size: 14rpx;
}

.create_form_item .title {
	display: inline-block;
	color: #101d37;
	font-size: 14px;
	margin-left: 5px;
	width: 85px;
}

.create_form_item input {
	color: #101d37;
	font-size: 14px;
	width: 243px;
	height: 36px;
	border-radius: 4px;
	border: solid 1px #d9d9d9;
	padding-left: 20px;
}

.imgupload {
	width: 160px;
	height: 214px;
	position: relative;
}
.imgupload img {
	width: 160px;
	height: 214px;
}
.imgupload input {
	font-size: 14px;
	width: 160px;
	height: 214px;
	opacity: 0;
	color: transparent;
	position: absolute;
	top: 0;
	left: 0;
}
</style>